import {
  Container,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import OrganizationSelect from 'features/organization/components/organizationSelect';
import UserSelectByOrg from 'features/user/components/userSelectByOrg';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';

export default function CustomerInfo() {
  const { values, setFieldValue, errors } = useFormikContext();
  const [selectedOrg, setSelectedOrg] = useState();

  return (
    <Container header={<Header variant="h2">Customer Info</Header>}>
      <SpaceBetween size="m">
        <OrganizationSelect
          errorText={errors.organization}
          selectedOrgId={values.organization}
          onOrgChange={(orgData, isManualChange) => {
            setFieldValue('organization', orgData.id);
            if (isManualChange) setFieldValue('uid', ''); // reset selected user when org changes
            setSelectedOrg(orgData);
          }}
        />

        <UserSelectByOrg
          label="Customer"
          errorText={errors.uid}
          organization={selectedOrg}
          selectedUserId={values.uid}
          onUserChange={(userData) => {
            setFieldValue('uid', userData.id);
            if (userData.organization && userData.organization !== values.organization) {
              setFieldValue('organization', userData.organization);
            }
          }}
          canAddUser
        />
      </SpaceBetween>
    </Container>
  );
}
